import React from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useGoogleLogin } from '@react-oauth/google'

import { Button } from 'components/ui/Button'

import { authApi, callApi, profileApi } from 'api'

import { setIsPro, logIn } from '../../store/actions'

const Auth = (props) => {
  const history = useHistory()
  const responseGoogle = (res) => {
    props.isPro
      ? authApi.getGoogleContacts(res?.code).then((res) => {
          let contacts = res?.filter((e) => e.emailAddresses)
          window.localStorage.setItem('contacts', contacts)
        }) &&
        authApi.googleLogInPro({ code: res?.code }).then(async (res) => {
          if (res?.result?.access_token) {
            props.setIsPro(true)
            localStorage.setItem('token', res?.result?.access_token)
            localStorage.setItem('refreshToken', res?.result?.refresh_token)
            localStorage.setItem('isPro', true)
            profileApi.setProInfo({
              channel_name: props.channelName
                ?.toString()
                .split('')
                .filter((e) => e !== ' ')
                .join(''),
              name: props.channelName?.toString(),
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            })
            await profileApi
              .getProfileInfo()
              .then((res) => props.logIn(res.result.profile))
            history.push('/pro/category')
          }
        })
      : authApi
          .googleLogInUser({
            code: res?.code,
            redirect_uri: window.location.href,
          })
          .then(async (res) => {
            if (res?.result?.access_token) {
              props.setIsPro(false)
              localStorage.setItem('token', res?.result?.access_token)
              localStorage.setItem('refreshToken', res?.result?.refresh_token)
              localStorage.setItem('isPro', false)
              await profileApi
                .getUserInfo()
                .then((res) => props.logIn(res.result.profile))
              props.data.callRequest
                ? props.data.event
                  ? history.push('/user/payments', props.data)
                  : callApi.sendCallRequest(props.data.callRequest).then((res) =>
                      history.push('/user/payments', {
                        ...props.data,
                        call_id: res?.result?.call_info,
                      })
                    )
                : history.push('/dashboard/user')
            }
          })
  }

  const login = useGoogleLogin({
    flow: 'auth-code',
    redirect_uri: window.location.href,
    onSuccess: responseGoogle,
    scope:
      'https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar.events.readonly https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid https://www.googleapis.com/auth/contacts.readonly',
    onError: (error) => console.error('Login Failed:', error),
  })

  return (
    <Button
      variant="tertiary"
      size="lg"
      iconName="google_white"
      fullWidth
      iconTextCenter
      onClick={() => login()}
    >
      Login with Google
    </Button>
  )
}

const mapStateToProps = ({ auth: { error, attributes } }) => ({
  authError: error,
  attributes,
})

const willMapDispatchToProps = {
  setIsPro,
  logIn,
}

export default connect(mapStateToProps, willMapDispatchToProps)(Auth)
